import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation addProcessingUser($username: String!) {
      createProcessingUser(username: $username) {
        success
      }
    }
  `,
  mutationName: "addProcessingUser",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/addProcessingUser.js